import { css } from 'lit';
/**
 * Styles used in all icon components.
 */
export const iconStyles = css `
  :host([size='s8']) {
    height: var(--zui-icon-size-8);
    width: var(--zui-icon-size-8);
  }

  :host([size='s12']) {
    height: var(--zui-icon-size-12);
    width: var(--zui-icon-size-12);
  }

  :host([size='s16']) {
    height: var(--zui-icon-size-16);
    width: var(--zui-icon-size-16);
  }

  :host([size='s24']) {
    height: var(--zui-icon-size-24);
    width: var(--zui-icon-size-24);
  }

  :host([size='s32']) {
    height: var(--zui-icon-size-32);
    width: var(--zui-icon-size-32);
  }

  :host([size='s40']) {
    height: var(--zui-icon-size-40);
    width: var(--zui-icon-size-40);
  }

  :host([size='s48']) {
    height: var(--zui-icon-size-48);
    width: var(--zui-icon-size-48);
  }

  :host([size='s64']) {
    height: var(--zui-icon-size-64);
    width: var(--zui-icon-size-64);
  }

  :host([size='s72']) {
    height: var(--zui-icon-size-72);
    width: var(--zui-icon-size-72);
  }

  :host([size='s80']) {
    height: var(--zui-icon-size-80);
    width: var(--zui-icon-size-80);
  }

  svg {
    display: block;
    height: 100%;
    width: 100%;
  }

  /* Regular Icon Colors */
  .svg-bg {
    fill: var(--zui-color-icon-background-default);
  }

  .svg-fg {
    fill: var(--zui-color-icon-foreground-default);
  }

  /* EWI Icon Colors */
  :host(zui-icon-alerts-ewi-question) .svg-bg {
    fill: var(--zui-color-help);
  }

  :host(zui-icon-alerts-ewi-info) .svg-bg {
    fill: var(--zui-color-info);
  }

  :host(zui-icon-alerts-ewi-check) .svg-bg {
    fill: var(--zui-color-success);
  }

  :host(zui-icon-alerts-ewi-warning-triangle) .svg-fg,
  :host(zui-icon-alerts-ewi-warning-round) .svg-fg {
    fill: var(--zui-color-icon-foreground-warning);
  }

  :host(zui-icon-alerts-ewi-warning-triangle) .svg-bg,
  :host(zui-icon-alerts-ewi-warning-round) .svg-bg {
    fill: var(--zui-color-warning);
  }

  :host(zui-icon-alerts-ewi-error-triangle) .svg-bg,
  :host(zui-icon-alerts-ewi-error-round) .svg-bg {
    fill: var(--zui-color-error);
  }

  /* ZEISS brand logo color fix */
  /* TODO: should be fixed upstream by the design team */
  :host(zui-icon-zeiss) .svg-fg {
    fill: #fff;
  }
`;
